import { render } from "./BtnRound.vue?vue&type=template&id=233961af"
import script from "./BtnRound.vue?vue&type=script&lang=js"
export * from "./BtnRound.vue?vue&type=script&lang=js"

import "./BtnRound.vue?vue&type=style&index=0&id=233961af&lang=css"
script.render = render

export default script